import {createContext} from 'react';

const MainSidebarContext = createContext(null);

export default MainSidebarContext;
